module.exports = __webpack_public_path__ + "media/images/bg-concentrated-left-1fe9821c491b74aaa1f52817e9fd1def.svg";